<template>
  <div :class="{'tree-container': true,'no-mask': !maskType}">
    <div class="mask-mode" v-if="maskType">
      <div v-if="!mutiple" class="rel-l">
        <input readonly="readonly" class="text-show" @focus="showMask"  :value="showText" placeholder="请选择地区">
        <img class="cl-btn" src="/img/ui/law/clear.png" @click.stop="clear">
      </div>
      <!-- @clear="clear" -->
        <!-- suffix-icon="el-icon-close" -->
      <div v-else class="muti-input" @click.stop="showMask">
        <div style="z-index: 2000;" class="ivu-tag ivu-tag-checked" v-for="(item, index) in showTextMuti" :key="index">
          <span class="ivu-tag-text">{{item}}</span>
          <i class="ivu-icon ivu-icon-ios-close" @click.stop="deleteChoose(index)"></i>
        </div>
      </div>
      <transition name="mask">
        <div class="mask"  v-show="maskShow">
          <transition name="select-container">
            <div class="tree-select-container" v-show="maskShow">
              <div class="tree-select-title">
                <div class="title-content">
                  <slot name="title"></slot>
                </div>
                <div class="close-icon" @click.stop="hideMask()">
                  <img src="/img/ui/law/close.png" alt="">
                </div>
              </div>
              <div class="search-container">
                <!-- <input class="search" v-model="keyword" ref="searchInput" placeholder="可输入关键字搜索" @keyup="searchByKeyword()"> -->
                <transition name="search-result">
                  <div class="search-result-list" v-if="searchResult.length">
                    <div v-for="id of searchResult" class="search-result" tabindex='0' ref="searchResult" @keyup.enter.stop="chooseSearchResult(id)" @click.stop="chooseSearchResult(id)" :key="id">
                      {{ calShowText(id) }}
                    </div>
                  </div>
                </transition>
              </div>
              <div class="tree-select">
                <tree-node class="choice-root" :chooseList="chooseList" :props="props" :treeData="treeData">
                  <template v-slot:default="{ node }">
                    <slot :node="node">{{ node[props.title] }}<span class="code">{{ node[props.code] }}</span></slot>
                  </template>
                </tree-node>
              </div>
              <div class="mutiple-selected" v-if="mutiple">
                <div class="selected">已选地区:
                  <template v-if="showTextMuti && showTextMuti.length">
                    <div class="ivu-tag ivu-tag-checked" v-for="(item, index) in showTextMuti" :key="index">
                      <span class="ivu-tag-text">{{item}}</span>
                      <i class="ivu-icon ivu-icon-ios-close" @click.stop="deleteChoose(index)"></i>
                    </div>
                  </template>
                  <span v-else>无</span>
                </div>
                <button type="success" class="button" @click.stop="addChoose">添加当前选中地区</button>
              </div>
              <div class="tree-select-menu">
                <button type="primary" class="button sure" @click.stop="submitChoose">确定</button>
                <button type="text" class="button cancle" v-if="!this.mutiple" @click.stop="hideMask()">取消</button>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </div>
    <div class="tree-select" v-else>
      <tree-node class="choice-root" :chooseList="chooseList" :props="props" :treeData="treeData">
      </tree-node>
    </div>
  </div>
</template>

<script>
import treeNode from './tree-node'

export default {
  components: {
    treeNode
  },
  props: {
    valueArray: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      required: true
    },
    maskType: {
      type: Boolean,
      default: true
    },
    value: {
      type: [Array, String, Number]
    },
    dataProps: {
      type: Object
    },
    customSearch: {
      type: Function
    },
    mutiple: {
      type: Boolean,
      required: false
    },
    mutiValue: {
      type: [Array],
      required: false
    }
  },
  data () {
    return {
      keyword: '',
      chooseList: [],
      chooseListMuti: [],
      maskShow: false,
      isTree: true,
      treeMap: {},
      defaultDataProps: {
        children: 'children',
        value: 'id',
        title: 'name',
        code: 'code'
      },
      searchResult: []
    }
  },
  computed: {
    props () {
      if (!this.dataProps) return this.defaultDataProps
      return Object.assign({}, this.dataProps, this.defaultDataProps)
    },
    showText () {
      if (!this.chooseList.length) return ''
      if (this.chooseList.some(id => !this.treeMap[id])) return ''
      const areaList = this.chooseList.map(id => this.treeMap[id][this.props.title])
      return areaList.join('/')
    },
    showTextMuti () {
      if (!this.chooseListMuti.length) return []
      const array = []
      let newItem = []
      for (const item of this.chooseListMuti) {
        console.log('item', item)
        newItem = item.map(id => this.treeMap[id][this.props.title])
        newItem = newItem.join('/')
        array.push(newItem)
      }
      return array
    }
  },
  watch: {
    treeData () {
      this.generateTreeMap()
    },
    value () {
      this.syncValue()
    },
    mutiValue (value) {
      if (value) {
        this.syncMutiValue()
      }
    }
  },
  created () {
    this.generateTreeMap()
    this.$on('choose-node', this.chooseNode)
    if (this.mutiValue && this.mutiValue.length) {
      this.syncMutiValue()
    }
  },
  beforeDestroy () {
    this.$off('choose-node')
  },
  methods: {
    generateTreeMap (list) {
      if (!list) {
        list = this.treeData
        this.treeMap = {}
      }
      list.forEach(data => {
        this.treeMap[data[this.props.value]] = data
        data[this.props.children] && this.generateTreeMap(data[this.props.children])
      })
    },
    showMask () {
      this.maskShow = true
      // this.$nextTick(() => {
      //   this.$refs.searchInput.focus()
      // })
    },
    hideMask (manual = true) {
      this.maskShow = false
      manual && this.syncValue()
    },
    syncValue () {
      if (!this.valueArray) {
        if (!this.value) {
          this.chooseList = []
          return
        }
        let parentId = this.value
        const list = []
        while (parentId) {
          list.unshift(parentId)
          parentId = this.treeMap[parentId] ? this.treeMap[parentId].parentId : null
        }
        if (list.length === this.chooseList && list.every((value, idx) => value === this.chooseList[idx])) return
        this.chooseList = list
      } else {
        if (!this.value) {
          this.chooseList = []
          return
        }
        if (this.value.length === this.chooseList.length && this.chooseList.every((value, idx) => this.value[idx] === value)) return
        this.chooseList = [...this.value]
      }
    },
    syncMutiValue () {
      for (const item of this.mutiValue) {
        let parentId = item
        const list = []
        while (parentId) {
          list.unshift(parentId)
          parentId = this.treeMap[parentId] ? this.treeMap[parentId].parentId : null
        }
        if (list.length === this.chooseListMuti && list.every((value, idx) => value === this.chooseListMuti[idx])) return
        this.chooseListMuti.push(list)
      }
    },
    chooseNode (node) {
      const value = node[this.props.value]
      if (!node.parentId) {
        this.chooseList = [value]
      } else {
        for (let idx = this.chooseList.length - 1; idx >= 0; idx--) {
          if (this.chooseList[idx] === node.parentId) break
          this.chooseList.splice(idx, 1)
        }
        this.chooseList.push(value)
      }
      if ((!this.maskType || !node.children || !node.children.length) && !this.mutiple) {
        this.submitChoose()
      }
    },
    addChoose () {
      console.log('chooselist:', this.chooseList)
      this.chooseListMuti.push(this.chooseList)
      this.chooseList = []
    },
    deleteChoose (index) {
      this.chooseListMuti.splice(index, 1)
      this.$emit('muti-delete', index)
    },
    submitChoose () {
      if (!this.mutiple) {
        if (this.valueArray) {
          this.$emit('input', this.chooseList)
        } else {
          this.$emit('input', this.chooseList[this.chooseList.length - 1] || '')
        }
      } else {
        this.$emit('muti-input', this.chooseListMuti)
      }

      this.maskType && this.hideMask(false)
    },
    clear () {
      this.chooseList = []
      this.submitChoose()
      this.$emit('on-clear')
    },
    searchByKeyword () {
      if (!this.keyword) return
      if (this.customSearch) {
        this.searchResult = this.customSearch(this.keyword)
      } else {
        const list = []
        for (const key in this.treeMap) {
          const data = this.treeMap[key]
          if (data[this.props.title] && data[this.props.title].includes(this.keyword)) {
            list.push(data[this.props.value])
          }
        }
        this.searchResult = list
      }
      // this.searchResult.length && this.focusSearchResult(0)
    },
    calShowText (id) {
      const list = []
      let parentId = id
      while (parentId) {
        this.treeMap[parentId] && list.unshift(this.treeMap[parentId][this.props.title])
        parentId = this.treeMap[parentId] ? this.treeMap[parentId].parentId : null
      }
      return list.join('/')
    },
    chooseSearchResult (id) {
      const list = []
      let parentId = id
      while (parentId) {
        this.treeMap[parentId] && list.unshift(parentId)
        parentId = this.treeMap[parentId] ? this.treeMap[parentId].parentId : null
      }
      this.chooseList = list
      this.searchResult = []
    }
    // checkKeyDown (event, idx) {
    //   if (event.key === 'ArrowDown') {
    //     this.focusSearchResult(idx + 1)
    //   } else if (event.key === 'ArrowUp') {
    //     this.focusSearchResult(idx - 1)
    //   }
    // },
    // focusSearchResult (idx) {
    //   this.$nextTick(() => {
    //     if (this.$refs.searchResult[idx]) {
    //       this.$refs.searchResult[idx].focus()
    //     }
    //   })
    // }
  }
}
</script>

<style lang="stylus" scoped>
.tree-container
  color #333
  &.no-mask
    display flex
.muti-input
  width 100%
  height 32px
  border-radius 3px
  border 1px solid #dcdee2
  cursor pointer
  &:hover
    border 1px solid #2d8cf0
.mask-mode
  position relative
  .rel-l
    position relative
  .cl-btn
    width 0.4rem
    height 0.4rem
    position absolute
    top 0.15rem
    right 0
  .text-show
    outline none
    display block
    flex 1
    width 3.9rem
    box-sizing border-box
    padding 0 0.05rem 0 0.1rem
    height 0.7rem
    font-size 0.22rem
    border-radius 0.06rem
    border 0
    color #fff
    background rgba(255, 255, 255, 0.2)
    >>> i
      cursor pointer
      font-size 1.5rem
      box-sizing border-box
      border-radius 50%
      // &:hover
      //   background #EEF0F0
      &:active
        padding-left 1px
        padding-top 1px
  .clear
    background-color #cecece
    border-radius 5px
    position absolute
    right 0
    top 50%
    padding 2px 5px
    transform translate(0, -50%)
    cursor pointer
    &:hover
      background-color blue
      color #fff
.mask
  display none
  position fixed
  left 0
  right 0
  top 0
  bottom 0
  z-index 5000 // 比iview模态框更高优先级
  background rgba(0,0,0, .5)
  display flex
  align-items center
  justify-content center
  flex-direction column
  &::before
    content ''
    flex-grow 1
  &::after
    content ''
    flex-grow 3
  .tree-select-container
    max-width 90vw
    max-height 90vh
    height 40rem
    width 60rem
    background white
    border-radius 4px
    box-shadow 0 0 1px 1px #9B9B9B
    display flex
    flex-direction column
    z-index 1500
    padding 0.24rem
    .tree-select-title
      flex-shrink 0
      display flex
      align-items center
      justify-content space-between
      .title-content
        padding-bottom 0
        font-size 0.24rem
        display flex
        align-items center
        padding 0.12rem
      .close-icon
        align-self flex-start
        cursor pointer
        display flex
        align-items center
        justify-content center
        border-radius 50%
        &:hover
          background #ECECEC
        img
          width 0.4rem
          height 0.4rem
    .tree-select-menu
      flex-shrink 0
      text-align right
      padding-right 0.2rem
      padding-bottom 0.1rem
      .button
        margin-right 4px
        width 3rem
        border-radius 0.1rem
      .sure
        background #409EFF
        color #fff
      .cancle
        border 1px solid #E4E7ED
        background #fff
        color #333
    .mutiple-selected
      display flex
      justify-content space-between
      align-items center
      padding 0 0.2rem
      margin-bottom 0.1rem
      .selected
        font-weight bold
    .search-container
      color  #333
      margin 0 0.24rem
      position relative
      .search
        width 100%
      .search-result-list
        position absolute
        left 0
        right 0
        background white
        z-index 2
        box-shadow 0 3px 10px -3px #9B9B9B, 0 0 1px 0 #9B9B9B
        border-radius 2px
        max-height 60vh
        overflow auto
        .search-result
          padding .5rem
          cursor pointer
          &:hover
            background #D7E4FE

.tree-select
  user-select none
  position relative
  flex auto
  margin 0.24rem
  .choice-root
    position absolute
    border 1px solid #BFBFBF
    border-radius 2px
    left 0
    top 0
    right 0
    bottom 0
    padding 2px
    overflow-x auto

.mask-enter-active, .mask-leave-active
  transition opacity .5s
.mask-enter, .mask-leave-to
  opacity 0

.select-container-enter-active
  animation bounce-in .5s
.select-container-leave-active {
  animation bounce-in .5s reverse
}
@keyframes bounce-in {
  0% {
    transform scale(.8)
  }
  100% {
    transform scale(1)
  }
}
</style>
